import { useRef, useState } from 'react';

import { useIntersection } from 'react-use';

import { useProductViewTracking } from '~/features/tracking/hooks/useProductViewTracking';
import { IVariationDetails } from '~/lib/data-contract';

type UseProductViewModuleTrackingOptions = {
	listId?: string;
	listName?: string;
};

export const useProductViewModuleTracking = (items?: IVariationDetails[], opts?: UseProductViewModuleTrackingOptions) => {
	const [tracked, setTracked] = useState(false);
	const moduleRef = useRef<HTMLDivElement>(null);
	const observer = useIntersection(moduleRef, {});

	useProductViewTracking(items, {
		enable: !tracked && observer?.isIntersecting,
		onTrack: () => setTracked(true),
		listId: opts?.listId?.toLowerCase(),
		listName: opts?.listName?.toLowerCase(),
	});

	return {
		moduleRef,
	};
};
